const toggleMenuAction = (payload) => {
  return {
    type: "rotate",
    payload,
  };
};

export default toggleMenuAction;
